import { Button, Sheet, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { useSendOptimizelyEvent } from '@/scopes/common/infrastructure/ab-testing/optimizely/useSendOptimizelyEvent'
import ga4analyticsClient from '@/scopes/common/infrastructure/analytics/ga4analyticsClient'
import { useCookieConsent } from '@/scopes/common/infrastructure/cookie-consent/useCookieConsent'
import { createConsoleLogger } from '@/scopes/common/infrastructure/logging/consoleLogger'
import { useAccommodationContext } from '@/scopes/prices/components/AccommodationContext'
import {
  createBookingDraftSelector,
  isAccommodationAvailableSelector,
  pricesResponseSelector,
  selectedRoomInfosSelector,
} from '@/scopes/prices/components/selectors'
import { bookingDraftActions } from '@/scopes/prices/domain/actions/bookingDraftActions'
import { bookingDraftApiClient } from '@/scopes/prices/infrastructure/booking-draft'
import { newPricesStore } from '@/scopes/prices/infrastructure/store'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { isClient } from '@/utilities'

const { bookClickHandler, resetState } = bookingDraftActions({
  bookingDraftApiClient,
  analyticsClient: ga4analyticsClient,
  store: newPricesStore,
  logger: createConsoleLogger(),
})

export function BookNowButton() {
  const intl = useIntl()
  const { prices } = usePricesSelector(pricesResponseSelector)
  const { selectedRoomInfos: selectedRooms } = usePricesSelector(selectedRoomInfosSelector)
  const { error: isError } = usePricesSelector(createBookingDraftSelector)
  const accommodationContext = useAccommodationContext()
  const { isFlightOnly } = usePricesSelector(isAccommodationAvailableSelector)
  const bookingStepsUrl = useCMSPageField('PDP.pricetable.bookingStepsUrl')
  const cookieConsent = useCookieConsent()

  const getUrl = () => {
    if (!isClient())
      return ''
    return window.location.href
  }
  const [openErrorModal, setOpenErrorModal] = React.useState(false)
  const { sendEvent: sendOptimizelyEvent } = useSendOptimizelyEvent()

  React.useEffect(() => {
    setOpenErrorModal(isError)
  }, [isError])

  const handleOnCreateBooking = async () => {
    sendOptimizelyEvent('added_to_cart')

    bookClickHandler({
      prices,
      selectedRooms,
      accommodationContext,
      url: getUrl(),
      isFlightOnly,
      cookieConsent,
      nextStepUrl: bookingStepsUrl,
    })
  }

  const onCloseErrorModal = () => {
    setOpenErrorModal(false)
    resetState()
  }

  const onModalOpenChange = (open: boolean) => {
    if (!open) {
      onCloseErrorModal()
    }
  }

  return (
    <>
      <Button onClick={handleOnCreateBooking} data-qa="book-now-button">
        {intl.formatMessage({ id: 'price_basket_price_breakdown_cta' })}
      </Button>
      <Sheet.Root open={openErrorModal} onOpenChange={onModalOpenChange}>
        <Sheet.Body side="right">
          <Sheet.Header titleLabel={intl.formatMessage({ id: 'price_basket_book_now_error_title' })} />
          <Sheet.Content>
            <Typography variant="body-m-regular-tight" forwardedAs="p">
              {intl.formatMessage({ id: 'price_basket_book_now_error_description' })}
            </Typography>
          </Sheet.Content>
          <Sheet.Footer>
            <Button variant="primary" onClick={onCloseErrorModal}>
              {intl.formatMessage({ id: 'price_basket_book_now_error_button' })}
            </Button>
          </Sheet.Footer>
        </Sheet.Body>
      </Sheet.Root>
    </>
  )
}
